import Component from '../core/Component'
import Cleave from 'cleave.js'

export default class InputCleave extends Component {
    constructor(element, options = {}) {
        super(element, options, {
            cleaveOptions: {
                numericOnly: false
            },
            ...options
        })
    }

    prepare() {
        if (this.options.cleaveOptions.min || this.options.cleaveOptions.max) {
            this.element.addEventListener('keyup', (event) => {
                const max = this.options.cleaveOptions.max ?? Number.MAX_VALUE
                const min = this.options.cleaveOptions.min ?? Number.MIN_VALUE
                if (event.currentTarget.value) {
                    let val = parseFloat(event.currentTarget.value);
                    val = Math.min(Math.max(val,min),max)
                    if (Number.isNaN(val)) {
                        val = ''
                    }
                    event.currentTarget.value = val
                }
            })
        }
        new Cleave(this.element, this.options.cleaveOptions)

        //vyjimka, kdyztak refactor: custom logika pro Číslo Smlouvy o stavebním spoření
        if (this.element.closest('form')?.['contract_number']) {
            this.element.addEventListener('input', this.handleInputChange)
            this.element.addEventListener('keydown', this.handleInputChange)
            this.lastInputLength = 0
        }

        //vyjimka, kdyztak refactor: custom logika pro den a mesic
        if (this.element.closest('form')?.['birth_day'] || this.element.closest('form')?.['birth_month']) {
            this.element.addEventListener('keyup', (event) => {
                if (event.currentTarget.value === '0') {
                    event.currentTarget.value = ''
                }
            })
        }
    }

    handleInputChange = (event) => {
        const showError = () => {
            if (this.errorEl) {
                return
            }
            const errorEl = document.createElement('div')
            errorEl.className = "InputInfo"
            errorEl.innerHTML = 'Pro další číslo smlouvy je potřeba vyplnit znovu tento formulář.'

            const buttonEl = document.createElement('button')
            buttonEl.addEventListener('click', () => hideError())
            errorEl.appendChild(buttonEl)

            const parentEl = this.element.closest('.FormItem') ?? this.element.parentElement
            parentEl.appendChild(errorEl)
            console.log('add errror')
            this.errorEl = errorEl
        }

        const hideError = () => {
            if (!this.errorEl) {
                return
            }
            this.errorEl.parentElement.removeChild(this.errorEl)
            this.errorEl = null
        }

        const length = event.target.value.length
        console.log('show error', event.target.value.length, this.lastInputLength)
        if (length === 10 && this.lastInputLength === length) {
            showError()
        } else {
            hideError()
        }

        this.lastInputLength = event.target.value.length
    }
}